<mat-card class="payroll-report-card">
  <mat-card-header>
    <mat-card-title>部署単位レポート出力</mat-card-title>

  </mat-card-header>
  <mat-card-content>
    <mat-form-field>
      <mat-select placeholder="表示月度" id="month" name="month" [(ngModel)]="selectMonth" #month="ngModel">
        <mat-option *ngFor="let m of monthes" [value]="m.id">{{m.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-select placeholder="締め日" id="closingDay" name="closingDay" [(ngModel)]="selectClosingDayIndex" #closingDay="ngModel">
        <mat-option *ngFor="let m of closingDays" [value]="m.id">{{m.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-selection-list #targetTeam [(ngModel)]="selectedTeams">
      <mat-list-option *ngFor="let t of teams" [value]="t">
        {{t.name}}
      </mat-list-option>
    </mat-selection-list>
    <mat-card-actions>
        <button mat-raised-button (click)="createReport('CSV')">CSV出力</button>
        <button mat-raised-button (click)="createReport('PDF')">PDF出力</button>
        <mat-spinner diameter="20" style="display: initial;" *ngIf="isProcessing"></mat-spinner>
    </mat-card-actions>
  </mat-card-content>

</mat-card>
